import * as React from 'react'
import { slugifyWithSlashes } from 'utils/slugify'

export default function useBrandUrl(brand: string, brandPath: string) {
  return React.useMemo(() => {
    const isSelfBrand = [
      'VEGA',
      'PULSIVA',
      'JOBELINE',
      'ERWIN M.',
      'V-Touch'
    ].includes(brand)

    return isSelfBrand
      ? slugifyWithSlashes(`/category/${brandPath}/${brand}/`)
      : ''
  }, [brand, brandPath])
}
